import { Injectable } from '@angular/core';
@Injectable()
export class DBkeys {
  public static readonly CURRENT_USER = "current_user";
  public static readonly USER_PERMISSIONS = "user_permissions";
  public static readonly USER_CONTROLLERS = "user_controllers";
  public static readonly USER_ROLES = "user_roles";
  public static readonly ACTIVE_URLS = "active_urls";
  public static readonly ACCESS_TOKEN = "access_token";
  public static readonly ID_TOKEN = "id_token";
  public static readonly REFRESH_TOKEN = "refresh_token";
  public static readonly TOKEN_EXPIRES_IN = "expires_in";
  public static readonly CURRENT_USER_INFO = "current_user_info";
  public static readonly CURRENT_FISCAL_YEAR = "current_fiscal_year";
  public static readonly HAS_LOCAL_SETTING = "has_local_setting";
  public static readonly CURRENT_BRANCH = "current_branch";
  public static readonly CURRENT_BRANCH_ID = "current_branch_id";
  public static readonly LOOK_UP_INFO = "look_up_info";
  public static readonly REVIEW_FILTER_INFO = "review_filter_info";
  public static readonly POLICY_INFO = "policy_info";
  public static readonly SMARTWIFI_POLICY_INFO = "smartwifi_policy_info";
  public static readonly PRICE_LIST_INFO = "price_list_info";
  public static readonly TAX_DUTY = "tax_duty";
  public static readonly REMEMBER_ME = "remember_me";
  public static readonly LANGUAGE = "language";
  public static readonly HOME_URL = "home_url";
  public static readonly THEME = "theme";
  public static readonly SHOW_DASHBOARD_STATISTICS = "show_dashboard_statistics";
  public static readonly SHOW_DASHBOARD_NOTIFICATIONS = "show_dashboard_notifications";
  public static readonly SHOW_DASHBOARD_TODO = "show_dashboard_todo";
  public static readonly SHOW_DASHBOARD_BANNER = "show_dashboard_banner";
  public static readonly CURRENT_INFORMATION = "current_information";
  public static readonly PAY_CURENTYEAR_MONTH = "PayCurentYearMonth";
}
